/* istanbul ignore file */
import { ActionContext as VuexActionContext, Store } from 'vuex'
import { Namespace } from '@/store/Namespaces'

import { ServicesProperty } from '@/types/landlord-order.types'

export const namespace = (fragment: string) => `${Namespace.LandlordOrder}/${Namespace.LandlordOrderServices}/${fragment}`

export enum Setter {
  OrderType = 'setOrderType',
  OtherOrderType = 'setOtherOrderType',
  ActivationType = 'setActivationType'
}

export enum Action {
  UpdateOrderType = 'UpdateOrderType',
  UpdateOtherOrderType = 'UpdateOtherOrderType',
  UpdateActivationType = 'UpdateActivationType',
  ResetServices = 'ResetServices'
}

interface State {
  [ServicesProperty.OrderType]: string;
  [ServicesProperty.OtherOrderType]: string;
  [ServicesProperty.ActivationType]: string;
}

export type ActionContext = VuexActionContext<State, {}>

export const getOrderType = (store: Store<{}>): string => store.getters[namespace(ServicesProperty.OrderType)]
export const getOtherOrderType = (store: Store<{}>): string => store.getters[namespace(ServicesProperty.OtherOrderType)]
export const getActivationType = (store: Store<{}>): string => store.getters[namespace(ServicesProperty.ActivationType)]

export const updateOrderType = (store: Store<{}>, type: string): Promise<void> => store.dispatch(namespace(Action.UpdateOrderType), type)
export const updateOtherOrderType = (store: Store<{}>, type: string): Promise<void> => store.dispatch(namespace(Action.UpdateOtherOrderType), type)
export const updateActivationType = (store: Store<{}>, type: string): Promise<void> => store.dispatch(namespace(Action.UpdateActivationType), type)

export const resetServices = (store: Store<{}>): Promise<void> => store.dispatch(namespace(Action.ResetServices))

const landLordOrderServicesModule = {
  namespaced: true,
  state: {
    [ServicesProperty.OrderType]: null,
    [ServicesProperty.OtherOrderType]: null,
    [ServicesProperty.ActivationType]: null
  },
  getters: {
    [ServicesProperty.OrderType]: (state: State) => state.orderType,
    [ServicesProperty.OtherOrderType]: (state: State) => state.otherOrderType,
    [ServicesProperty.ActivationType]: (state: State) => state.activationType
  },
  mutations: {
    [Setter.OrderType]: (state: State, type: string) => {
      state.orderType = type
    },
    [Setter.OtherOrderType]: (state: State, value: string) => {
      state.otherOrderType = value
    },
    [Setter.ActivationType]: (state: State, type: string) => {
      state.activationType = type
    }
  },
  actions: {
    [Action.UpdateOrderType]: ({ commit }: ActionContext, value: string): void => {
      commit(Setter.OrderType, value)
    },
    [Action.UpdateOtherOrderType]: ({ commit }: ActionContext, value: string): void => {
      commit(Setter.OtherOrderType, value)
    },
    [Action.UpdateActivationType]: ({ commit }: ActionContext, value: string): void => {
      commit(Setter.ActivationType, value)
    },
    [Action.ResetServices]: ({ commit }: ActionContext): void => {
      commit(Setter.OrderType, null)
      commit(Setter.OtherOrderType, null)
      commit(Setter.ActivationType, null)
    }
  }
}

export default landLordOrderServicesModule
